<template>
  <div class="db-kpi-grid">
    <article v-for="item in items" :key="item.key" class="db-kpi-card" :class="`is-${item.tone}`">
      <div class="db-kpi-card__head">
        <p class="db-kpi-card__label">{{ item.label }}</p>
        <span class="db-kpi-card__trend">{{ item.badge }}</span>
      </div>
      <h3 class="db-kpi-card__value">{{ formatCurrency(item.value) }}</h3>
      <p class="db-kpi-card__meta">{{ item.meta }}</p>
    </article>
  </div>
</template>

<script>
export default {
  name: 'DashboardKpiGrid',
  props: {
    items: { type: Array, default: () => [] },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value || 0));
    },
  },
};
</script>

<style scoped>
.db-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.db-kpi-card {
  border-radius: 14px;
  border: 1px solid #d8e5eb;
  padding: 0.85rem 1rem;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(12, 45, 58, 0.07);
}

.db-kpi-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.45rem;
}

.db-kpi-card__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #4b6573;
}

.db-kpi-card__trend {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(115, 102, 255, 0.12);
  color: var(--theme-deafult);
}

.db-kpi-card__value {
  margin: 0;
  font-family: Poppins, "Segoe UI", sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: #0d2f3b;
}

.db-kpi-card__meta {
  margin: 0.35rem 0 0;
  font-size: 11px;
  color: #667d8a;
}

.db-kpi-card.is-income {
  background: linear-gradient(160deg, #ffffff 0%, rgba(115, 102, 255, 0.08) 100%);
}

.db-kpi-card.is-expense {
  background: linear-gradient(160deg, #ffffff 0%, rgba(247, 49, 100, 0.08) 100%);
}

.db-kpi-card.is-profit {
  background: linear-gradient(160deg, #ffffff 0%, rgba(115, 102, 255, 0.06) 100%);
}

.db-kpi-card.is-balance {
  background: linear-gradient(160deg, #ffffff 0%, rgba(247, 49, 100, 0.05) 100%);
}

@media (max-width: 1200px) {
  .db-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .db-kpi-grid {
    grid-template-columns: 1fr;
  }
}
</style>
